module.exports = __webpack_public_path__ + "img/bookconekt.f7c24e8b.jpg";